<!--  -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button v-if="permission.scanSaleOut" title="扫码出仓" size="small" class="search-btn" type="warning" @click="scanSLOut()">{{
                        permission.scanSaleOut
                    }}</el-button>
                    <el-button
                        v-if="permission.print"
                        size="small"
                        title="打印出库单，部分出仓及全部出仓的单据"
                        icon="el-icon-printer"
                        class="search-btn btn-primary"
                        @click="print()"
                        >{{ permission.print }}</el-button
                    >
                </div>
                <div class="search-ctn-right">
                    <div class="search-name">区域</div>
                    <el-select v-model="searchData.ZId" class="search-item" filterable clearable size="small" placeholder="请选择" @change="zoneChange">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未关联区域" value="未关联区域"></el-option>
                        <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <div class="search-name">出库单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        clearable
                        placeholder="出库单号"
                    ></el-input>
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Keyword"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="showSearch">更多条件</el-button>
                </div>
            </div>
            <div class="table-ctn whOrder-table">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    :data="tableData"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                    <template v-for="(col, index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            :class-name="col.ColumnCode === 'OutOrderCode' ? 'outorder-column' : ''"
                            v-if="col.ColumnCode == 'OutOrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <el-badge :value="'打印' + scope.row.PrintedCount + '次'"  class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                    <el-tag @click="showOrderPreview(scope.row)" class="codetag"> {{ scope.row.OutOrderCode }}</el-tag>
                                </el-badge>
                                <span v-else> {{ scope.row.OutOrderCode }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{ scope.row.OrderCode }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'WarehouseName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{ scope.row.WarehouseName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OutWarehouseStateName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                                <i v-else-if="scope.row.OutWarehouseStateName == '部分出仓'" style="color: orange;">{{ scope.row.OutWarehouseStateName }}</i>
                                <i v-else :class="scope.row.IsEnoughStore && !scope.row.IsDelivery ? 'c-active' : ''">{{ scope.row.OutWarehouseStateName }}</i></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.saleOut && !scope.row.IsDelivery"
                                    title="出仓"
                                    size="mini"
                                    type="text"
                                    @click="add(scope.row)"
                                    >{{ permission.saleOut }}</el-button
                                >
                                <el-button
                                    v-if="permission.scanSaleOut && !scope.row.IsDelivery && scope.row.WarehouseType != 1"
                                    title="扫码出仓"
                                    size="mini"
                                    type="text"
                                    @click="scanOut(scope.row)"
                                    >{{ permission.scanSaleOut }}</el-button
                                >
                                <el-button v-if="permission.checkLabels" title="查看标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看标签</el-button>
                                <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{
                                    permission.opRecords
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
                <!--分页控件加if条件是因为，我们返回当前页面取得总条数totalNum的之前，element-ui的分页组件已经在页面加载完毕，
                当时的totalNum绑定的是data里面初始化的数据0，所以当总条数为0的时候，分页组件的页码默认为1。并且当totalNum在created生命周期里取得数据后
        ，分页组件也不会刷新。所以这就导致， 页面内容正确，但是页码高亮依旧是第一页。而且current-page要添加sync修饰符-->
            </div>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printContent2 @closeDialog="closeDialog" :printId="multipleSelection[0].OutOrderId"></printContent2>
                </div>
            </el-dialog>         
            <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkOrderLabels @closeDialog="closeLabelsDialog" :OrderId="orderId"></checkOrderLabels>
                </div>
            </el-dialog> 
            <el-dialog 
                :close-on-click-modal="false" 
                title="更多查询条件" 
                :visible.sync="showSearchDialog" 
                id="search-order-dialog"   
                custom-class="search-item-dialog"
                :modal="false"
                append-to-body v-dialog-drag lock-scroll
                width="400px">
                <div class="dialog-content" v-if="showSearchDialog">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="仓库区域">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.ZId"
                                filterable
                                clearable
                                @visible-change="wHVisibleChange($event)"
                            >
                                <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="出库单号">
                            <el-input
                                class="search-item"
                                size="small" 
                                v-model.trim="searchData.OrderCode" 
                                placeholder="请输入出库单号或销售单号"
                                >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="客户名称">
                            <el-input
                                class="search-item"
                                size="small" 
                                v-model.trim="searchData.Keyword" 
                                placeholder="请输入客户电话/名称"
                                >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.State"
                                filterable
                                clearable
                            >
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="出仓仓库">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.WarehouseId"
                                filterable
                                clearable
                                @visible-change="wHVisibleChange($event)"
                            >
                                <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                    <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="提交时间">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="dateTimes"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                :picker-options="pickerOptions"
                                @change="onDateTimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearch">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="出库单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
                <div class="dialog-content" v-if="OrderLifesVisible">
                    <ordersLifes :OrderId="OrderId" :OrderType="13" @closeDialog="closeOrderLifesDialog"></ordersLifes>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import timePicker from '@/components/common/timePicker';
import checkOrderLabels from '@/components/business/salesManage/checkSOutOrderLabels.vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import ordersLifes from '@/components/common/ordersLifes';
import Vue from 'vue';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        timePicker,
        breadcrumb,
        elTableColumn,
        ordersLifes,
        checkOrderLabels
    },
    props: ['type'],
    data() {
        return {
            tableCode: 'SalesOutWhOrdersTakeOut',
            loading: false,
            userInfo: this.$util.getLocalStorage('userMsg'),
            orderId:'',
            showLabelsDialog: false,
            showSearchDialog:false,
            multipleSelection: null,
            printDialogVisible: false,
            timeVisible: false,
            searchData: {
                State: '5',
                Keyword: '',
                ZId: '',
                WarehouseId:'',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            warehouseList:[],
            dateTimes:[],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '5' },
                { Text: '部分出仓', Value: '10' },
                { Text: '已出仓', Value: '15' }
            ],
            zoneList: [],
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            OrderLifesVisible:false,
            isUseBox: false //是否使用箱子
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    created() {
        if (this.tableCode)
            this.getSetsData().then(() => {
                this.getConfigByCodes();
            });
    },
    mounted() {
        let that = this;
        let zone = this.$util.getLocalStorage('zoneScreen'+this.userInfo.EmployeeId);
        if(zone){
            that.searchData.ZId = zone.Id;
        }
        that.searchCustom();
        that.$util.setEnterEvent(that, that.$route.fullPath);
        that.permission = that.$util.getPermission('SalesOutWhOrdersTakeOut');
        that.getZoneList();

        Vue.component('printContent2', function(resolve) {
            that.$util.getPrintComponents(13).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printZoneSalesOut'], resolve);
                }
            });
        });
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ckxz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ckxz':
                                this.isUseBox = result;
                                break;
                        }
                    }
                }
                this.getTableData();
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.OutOrderId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        closeDialog(isPrint) {
            this.printDialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.OutOrderId == this.multipleSelection[0].OutOrderId) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转编辑
        add(item) {
            this.$router.push(`/inventoryManage/salesOrder/saleOutTakeOut/outGoods?id=${item.OutOrderId}&ZoneId${item.ZoneId}&StoId${item.SId}`);
        },
        scanSLOut() {
            if (this.isUseBox) {
                this.$router.push(`/inventoryManage/salesOrder/saleOutTakeOut/scanOutBoxV?oid=`);
            } else this.$router.push(`/inventoryManage/salesOrder/saleOutTakeOut/scanOut?oid=`);
        },
        scanOut(item) {
            if (item.OutOrderId) {
                if (this.isUseBox) {
                    this.$router.push(`/inventoryManage/salesOrder/saleOutTakeOut/scanOutBoxV?oid=${item.OutOrderId}`);
                } else this.$router.push(`/inventoryManage/salesOrder/saleOutTakeOut/scanOut?oid=${item.OutOrderId}`);
            } else {
                this.$util.warningMsg('请选择要出仓的销售出库单');
            }
        },
        resetSearch() {
            this.searchData = {
                State: '5',
                Keyword: '',
                ZId: '',
                WarehouseId:'',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            that.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOutWhOrderList',
                    data: that.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    if (that.searchData.page == 1) {
                        that.tableDataLength = res.count;
                     }
                    that.multipleSelection = null;
                    that.$refs.multipleTable.clearSelection();
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add(event);
            }
        },
        getZoneList() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneDataList',
                    data: {
                        WarehouseId: ""
                    }
                })
                .then(res => {
                    that.zoneList = res.data;
                });
        },
        showSearch(){
            this.showSearchDialog = true;
        },
        zoneChange(value){
            var zone = "";
            if(value){
                if(value == "未关联区域"){
                    this.searchData.ZId = "未关联区域";
                    zone = {
                        Id : "未关联区域",
                        Name : "未关联区域"
                    }
                }else{
                    zone = this.zoneList.find(x=>x.Id == value)
                    this.searchData.ZId = zone.Id;
                }

            }else{
                this.searchData.ZId = "";
            }
            this.$util.setLocalStorage('zoneScreen' + this.userInfo.EmployeeId,zone);
        },
        closeSearch(){
            this.showSearchDialog = false;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(0).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        // 打印
        print() {
            let that = this;
            if (that.multipleSelection == null || that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择一张销售出库单打印');
                return;
            } else if (that.multipleSelection.length > 1) {
                that.$util.warningMsg('只能选择一张销售出库单打印');
                return;
            }
            that.printDialogVisible = true;
        },
        getSetsData() {
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);
                        });
                        resolve();
                    })
                    .catch(err => {
                        resolve();
                    });
            });
        },
        opRecords(item) {
            let id = item ? item.OutOrderId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 1 || index === 11 || column.property == 'CallNum' || column.property == 'SName' || column.property == 'PayTypeName') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },     
        //关闭订单弹出层
        closeLabelsDialog() {
            this.orderId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.orderId = row.OutOrderId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },   
    }
};
</script>
<style lang="less" scoped>
.el-form-item{
    margin-bottom: 1px !important;
}
.el-input--small .el-input__inner{
    height: 35px;
}
.dialog-footer{
    text-align: right;
}
.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
    padding: 0;
    height: 11px;
    line-height: 12px;
    z-index:999;
    color: inherit !important; 
}

</style>
<style lang="less">
// 合计行会遮挡表格最右下的单元格
.whOrder-table {
    .el-table__fixed-footer-wrapper{
        z-index: 1;
    }
}
.whOrder-table {
    .el-table__row {
        td.outorder-column {
            .cell {
                overflow: visible !important;
            }
        }
    }
}
</style>